import emptyRibbon from 'common/assets/svg/common/ribbon-line.svg';
import solidRibbon from 'common/assets/svg/common/ribbon-solid.svg';
import folder from 'common/assets/svg/common/folder.svg';
import burger from 'common/assets/svg/common/chapter.svg';
import TextWithTooltip from 'common/components/general/TextWithTooltip';
import { capitalizeFirst } from 'common/utils/texts';
import SvgRender from 'common/components/general/SvgRender';
import { FC, ReactNode } from 'react';

type TitleWithIconProps = {
  hideIcon?: boolean;
  onClick?: () => void;
  customIconComponent?: ReactNode;
  parent_id?: string | number | null;
  type?: string | null;
  post_count?: number;
  preffix?: string;
  title: ReactNode;
  draft_change_request_count?: number;
  customIcon?: string;
  withRibbon?: boolean;
  withFolder?: boolean;
  isHighlighted?: boolean;
};

const TitleWithIcon: FC<TitleWithIconProps> = ({
  hideIcon,
  onClick,
  customIconComponent,
  parent_id,
  type,
  post_count,
  preffix,
  title,
  draft_change_request_count,
  customIcon,
  withRibbon,
  withFolder,
  isHighlighted
}) => {
  return (
    <div
      className={`cursor-pointer d-flex align-items-center h-100p flex-1 overflow-hidden chapters-tree__view-title--inner ${
        hideIcon ? 'cps-4' : ''
      }`}
      onClick={onClick}
    >
      {customIconComponent ? (
        customIconComponent
      ) : parent_id && post_count ? (
        <SvgRender
          className={`ms-3 me-1 ${
            parent_id && post_count
              ? `text-${draft_change_request_count ? 'violet' : 'yellow'}`
              : ''
          }`}
          src={post_count ? solidRibbon : emptyRibbon}
          style={{ minWidth: 14, maxWidth: 14, height: 14 }}
        />
      ) : !hideIcon ? (
        <img
          className="ms-3 me-1 tree-title-ribbon"
          alt="ribbon"
          src={
            customIcon
              ? customIcon
              : withRibbon
                ? emptyRibbon
                : withFolder
                  ? folder
                  : !parent_id
                    ? burger
                    : emptyRibbon
          }
          width={14}
          height={14}
        />
      ) : null}
      <div
        className={`overflow-hidden text-nowrap fw-medium flex-1 fs-14 ${
          isHighlighted ? 'highlighted' : ''
        } `}
      >
        <TextWithTooltip>
          {preffix ? <span>{preffix} &nbsp;</span> : null} {title}
          {type ? (
            <>
              <span className="text-violet mx-1">|</span>
              <span className="text-violet fs-14 fw-normal">
                {capitalizeFirst(type.split('_').join(' '))}
              </span>
            </>
          ) : null}
        </TextWithTooltip>
      </div>
    </div>
  );
};

export default TitleWithIcon;
